'use client';
import React from 'react';
import Link from 'next/link';
import Footer from '@/components/Shared/Footer';
import Image from 'next/image';

interface Props {
  children: React.ReactNode;
}

export const PrivacyTermsWrapper = ({ children }: Props) => {
  return (
    <div className="relative h-screen overflow-hidden">
      <div className="flex flex-col h-full">
        {/* Header */}
        <header className="bg-white py-4">
          <div className="container mx-auto px-4 flex justify-between items-center">
            <div className="flex items-center">
              <Link href="/">
                <Image
                  src="/images/logo.svg"
                  alt="Logo"
                  width={200}
                  height={150}
                />
              </Link>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-grow overflow-y-auto">
          <div className="container mx-auto py-8 px-4">
            <div className="bg-white mx-auto rounded-lg md:w-2/3 md:p-8 ">
              {children}
            </div>
          </div>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyTermsWrapper;
